import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import PropTypes from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import history from 'store/history';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Input from '@material-ui/core/Input';
import AvatarEditor from 'exif-react-avatar-edit';
// import history from 'store/history';
import { callServer, uploadFile } from 'utils/apiFetch';
import { sessionService } from 'redux-react-session';
import CodeOfHonor from 'components/CodeOfHonor';
import { acceptCodeOfHonor } from 'components/CodeOfHonor/modules/actions';
import Linkedin from '../../../assets/images/linkedin.svg';
import { EMAIL } from '../../../constants/patterns';
import { ROUTE_LOGIN, ROUTE_INITIATIVES } from '../../../constants/urls';
import {
  SignupWrapper, Delete, AvatarOverflow, ButtonLogin, PrevInfo,
  ProfilePhotoWrapper, LinkedInWrapper,
} from './styles';
import './styles.css';


function Transition(props) {
  return <Slide direction='down' {...props} />;
}

class Signup extends Component {
  static propTypes = {
    literals: PropTypes.object.isRequired,
    signupData: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    doSignup: PropTypes.func.isRequired,
    uploadImage: PropTypes.func.isRequired,
    doSignupSocial: PropTypes.func.isRequired,
    // setAutoNavigation: PropTypes.func.isRequired,
    setSplashScreen: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const { app } = this.props;
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      linkedInUrl: '',
      lang: app.lang,
      term: false,
      open: false,
      openEditor: false,
      previewAvatar: '',
      emailValid: false,
      formValid: false,
      flagCodeOfHonor: false,
      profilePhoto: false,
      linkedIn: false,
    };
  }

  

  showCodeOfHonor = (flag = true) => {
    this.setState({ flagCodeOfHonor: flag });
  }

  onCloseAvatar = () => {
    this.setState({ previewAvatar: null });
  }

  onCropAvatar = (previewAvatar) => {
    this.setState({ previewAvatar });
  }

  showAvatarEditor = () => {
    this.setState({ openEditor: true });
  }

  assignHiddenFileInput = (ref) => {
    this.hiddenFileInput = ref;
  }

  
  handleChange = name => (event) => {
    let value = event.target.value;
    if (name === 'term') {
      value = event.target.checked;
    }
    this.setState({
      [name]: value,
    }, () => {
      this.validateField(name, value);
    });
  };

  
  validateField = (fieldName, value) => {
    let { emailValid } = this.state;

    switch (fieldName) {
      case 'email':
        emailValid = value.match(EMAIL);
        break;
      default:
        break;
    }

    this.setState({
      emailValid,
    }, this.validateForm);
  };

  
  validateForm = () => {
    const {
      firstName,
      lastName,
      emailValid,
    } = this.state;

    return this.setState({
      formValid: (firstName !== '' && lastName !== '' && emailValid),
    });
  };

  
  clearForm = () => {
    this.setState({
      firstName: '',
      lastName: '',
      email: '',
      linkedInUrl: '',
      emailValid: false,
      formValid: false,
      scale: 1,
    });
  };

  
  removeImage = () => {
    this.setState({ image: null });
  };

  
  onChange = (e) => {
    const files = Array.from(e.target.files);
    const formData = new FormData();
    files.forEach((file, i) => {
      formData.append(i, file);
    });
    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        image: reader.result,
        openEditor: true,
      });
    };
    reader.readAsDataURL(file);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleEditorClose = () => {
    this.setState({ openEditor: false });
  };

  handleOpenTerms = () => {
    this.setState({ open: true });
  }

  handleAvatarClick = () => {
    this.hiddenFileInput.click();
  }

  handleCloseProfile = () => {
    this.setState({
      profilePhoto: false,
      linkedIn: true,
    });
  }

  handleAvatarUpload = (event) => {
    uploadFile(event.target.files[0], 'avatar')
      .then((response) => {
        if (response.success) {
          this.setState({ image: response.info.url });
        }
      });
  }

  onSubmit = (event) => {
    const { setSplashScreen } = this.props;
    const {
      term, formValid,
    } = this.state;

    if (!term) {
      this.setState({
        open: true,
      });
    } else if (formValid) {
      setSplashScreen(false);
      this.showCodeOfHonor();
    }
    event.preventDefault();
    return false;
  };

  handleSubmit = () => {
    const { doSignup, showLoading } = this.props;
    const {
      firstName, lastName, email, password, lang, image, linkedInUrl,
    } = this.state;
    doSignup({
      name: firstName, surname: lastName, email, password, lang, image, linkedInUrl,
    }).then(() => {
      const params = {
        narrativeType: 'basic_profile',
        type: 'code_of_honor',
        name: 'accept',
      };
      acceptCodeOfHonor(params);
      history.push('/initiatives');
    });
  }

  zoomIn = () => {
    let { scale } = this.state;
    if (scale === 1) {
      scale = -2;
    } else {
      scale -= 1;
    }
    this.setState({ scale });
  };

  zoomOut = () => {
    let { scale } = this.state;
    if (scale === -1) {
      scale = 2;
    } else {
      scale += 1;
    }
    this.setState({ scale });
  };

  rotateLeft = (e) => {
    e.preventDefault();
    const { rotate } = this.state;
    this.setState({
      rotate: rotate + 90,
    });
  };

  handleSave = () => {
    const { uploadImage } = this.props;
    const { previewAvatar } = this.state;
    const img = previewAvatar;
    this.setState({
      image: img,
      openEditor: false,
    });
    uploadImage(img, 'avatar');
  };

  setEditorRef = (editor) => {
    if (editor) this.editor = editor;
  };

  responseSocial = () => {
    const { doSignupSocial } = this.props;
    doSignupSocial();
  };

  openLinkedin = () => {
    const origin = window.location.origin;
    const tabLogin = window.open(
      `${origin}/system/security/external/oauth.php?oa_ref=3c90c80eb1c2b395af81dd463425731545396064`,
      '_blank',
      'width=600,height=480',
    );
    const watchClose = setInterval(() => {
      if (tabLogin.closed) {
        clearTimeout(watchClose);
        const params = {
          t: 'oauth_3c90c80eb1c2b395af81dd463425731545396064',
        };
        callServer('GET', `${origin}/system/security/external/get_login_response.php`, params)
          .then((response) => {
            if (response.success) {
              sessionService.saveSession({ token: response.data.user_code })
                .then(() => {
                  const { user_id: id, user_code: userCode } = response.data;
                  sessionService.saveUser({ id, user_code: userCode })
                    .then(() => {
                      this.responseSocial();
                    });
                });
            }
          });
      }
    }, 200);
  }

  showProfilePhoto = () => {
    this.setState({
      profilePhoto: true,
    });
  }

  handleAcceptCodeOfHonor = () => {
    this.showCodeOfHonor(false);
    this.showProfilePhoto();
  }

  handleChangeUrl = (event) => {
    const value = event.target.value;
    this.setState({
      linkedInUrl: value,
    });
  }

  render() {
    const {
      literals,
      location,
      signupData: {
        success,
        error,
      },
      app,
    } = this.props;

    const {
      firstName,
      lastName,
      email,
      password,
      term,
      image,
      open,
      openEditor,
      flagCodeOfHonor,
      profilePhoto,
      linkedIn,
      linkedInUrl,
    } = this.state;

    const content = () => {
      if (image && image !== '') {
        return (
          <div className='fadein'>
            <div
              onClick={() => this.removeImage()}
              className='delete'
            >
              <Delete className='fa fa-times' />
            </div>
            <img
              src={image}
              alt={literals.image}
            />
          </div>
        );
      }
      return (
        <React.Fragment>
          <input
            type='file'
            ref={this.assignHiddenFileInput}
            onChange={this.handleAvatarUpload}
            style={{ display: 'none' }}
          />
          <div className='button'>
            <div onClick={this.handleAvatarClick}>
              <i className='fa fa-user' id='user' />
            </div>
          </div>
        </React.Fragment>
      );
    };


    if (flagCodeOfHonor) {
      return (
        <div className='codeOfHonor'>
          <CodeOfHonor
            onAccept={this.handleAcceptCodeOfHonor}
          />
        </div>
      );
    }

    if (profilePhoto) {
      return (
        <ProfilePhotoWrapper>
          <div className='content'>
            <p>
              {literals.photoText}
              <br />
              {literals.photoPutFace}
            </p>
            {content()}
            <ButtonLogin onClick={this.handleAvatarClick}>
              {literals.photoAddProfile}
            </ButtonLogin>
            <p>
              {literals.photoSubtext}
            </p>
            <ButtonLogin onClick={this.handleCloseProfile}>
              {literals.next}
            </ButtonLogin>
          </div>
        </ProfilePhotoWrapper>
      );
    }

    if (linkedIn) {
      return (
        <LinkedInWrapper>
          <div className='content'>
            <div className='button'>
              <div onClick={this.handleAvatarClick}>
                <i className='fab fa-linkedin-in' id='user' />
              </div>
            </div>
            <p>
              {literals.linkedInText}
            </p>
            <input
              placeholder={literals.linkedInUrl}
              value={linkedInUrl}
              onChange={this.handleChangeUrl}
            />
            <ButtonLogin onClick={this.handleSubmit}>
              {literals.next}
            </ButtonLogin>
          </div>
        </LinkedInWrapper>
      );
    }

    if (app.isAuthenticated) {
      return (
        <Redirect to={{
          pathname: ROUTE_INITIATIVES,
          state: location.state,
        }}
        />
      );
    }

    return (
      <SignupWrapper app={app}>
        <Grid container spacing={0} className='Signup__panel'>
          <Grid item xs={12} sm={12} md={12} className='Signup__panel--right'>
            <div className='Signup__panel--right__content'>
              <PrevInfo>
                <div className='title'>{literals.registry}</div>
                <div className='text'>{literals.enterData}</div>
                <div className='text'>{literals.yourAffiliation}</div>
              </PrevInfo>
              <div className='Signup__panel--right__content__form'>
                <ValidatorForm onSubmit={this.onSubmit} autoComplete='off'>
                  <div className='left'>
                    <TextValidator
                      id='adornment-email'
                      placeholder={literals.email}
                      type='text'
                      autoComplete='email'
                      value={email}
                      name='email'
                      onChange={this.handleChange('email')}
                      inputProps={{
                        className: 'form__field__input',
                      }}
                      validators={['required', 'isEmail']}
                      errorMessages={[literals.error.require, literals.error.email]}
                      className='form__field'
                    />
                    <TextValidator
                      id='adornment-password'
                      type='password'
                      placeholder={literals.password}
                      name='password'
                      autoComplete='password'
                      value={password}
                      onChange={this.handleChange('password')}
                      className='form__field'
                      validators={['required']}
                      errorMessages={[literals.error.require]}
                      inputProps={{
                        className: 'form__field__input',
                      }}
                    />
                  </div>
                  <TextValidator
                    id='adornment-firstName'
                    type='text'
                    placeholder={literals.firstName}
                    autoComplete='given-name'
                    value={firstName}
                    className='form__field'
                    name='firstName'
                    onChange={this.handleChange('firstName')}
                    inputProps={{
                      className: 'form__field__input',
                    }}
                    validators={['required']}
                    errorMessages={[literals.error.require]}
                  />
                  <TextValidator
                    id='adornment-lastName'
                    placeholder={literals.lastName}
                    type='text'
                    name='lastName'
                    className='form__field'
                    autoComplete='family-name'
                    value={lastName}
                    onChange={this.handleChange('lastName')}
                    inputProps={{
                      className: 'form__field__input',
                    }}
                    validators={['required']}
                    errorMessages={[literals.error.require]}
                  />
                  <div className='description'>
                    <Input
                      id='adornment-term'
                      type='checkbox'
                      value={term}
                      onChange={this.handleChange('term')}
                      inputProps={{
                        className: 'form__field__checkbox',
                      }}
                    />
                    {literals.rule}
                    <a className='link_conditions' onClick={this.handleOpenTerms}>{literals.rule2}</a>
                  </div>
                  {(success !== '') && (
                    <span className='state-message state-message--success' />
                  )}
                  {(error !== '') && (
                    <span className='state-message state-message--error'>{error}</span>
                  )}
                  <ButtonLogin
                    type='submit'
                  >
                    {literals.next}
                  </ButtonLogin>
                  <Link to={ROUTE_LOGIN} className='btn-login'>
                    {literals.loginActionBtn}
                  </Link>
                </ValidatorForm>
                <div className='Signup__panel--right__content__form__social hidden'>
                  <img src={Linkedin} alt='LinkedIn' onClick={this.openLinkedin} />
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          className='termDialog'
          onClose={this.handleClose}
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'
        >
          <DialogTitle id='alert-dialog-slide-title'>
            {literals.termTitle}
            <div
              onClick={this.handleClose}
              className='delete'
            >
              <i className='fa fa-times' />
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-slide-description'>
              <iframe title='terms_use' className='terms_use' src={app.url_policy} />
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Dialog
          open={openEditor}
          TransitionComponent={Transition}
          keepMounted
          className='avatarEditor'
          onClose={this.handleClose}
          aria-labelledby='alert-dialog-slide-title'
          aria-describedby='alert-dialog-slide-description'
        >
          <DialogTitle id='alert-dialog-slide-title'>
            {literals.avatar.title}
            <div
              onClick={this.handleEditorClose}
              className='delete'
            >
              <i className='fa fa-times' />
            </div>
          </DialogTitle>
          <DialogContent>
            <div>
              <AvatarOverflow>
                <AvatarEditor
                  image={image}
                  ref={this.setEditorRef}
                  width={160}
                  height={200}
                  border={0}
                  onCrop={this.onCropAvatar}
                  onClose={this.onCloseAvatar}
                />
              </AvatarOverflow>
              <div className='editor-btns'>
                <Button onClick={this.handleSave}>
                  {literals.avatar.ok}
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </SignupWrapper>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/routes/SignupTemp/components/index.jsx